import React, { Suspense, useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";

// Protected Route & Browser History
import ProtectedRoute from "./utils/Routing/ProtectedRoute";
import history from "./utils/Routing/history";
import Loading from "./components/Loading";

// Global CSS Styling
import "./CpeMod.css";
import ApiPath from "./utils/Apis/ApiPath";

// Container Components
//import Login from "./containers/Login";
const Login = React.lazy(() => import("./containers/Login"));
const Home = React.lazy(() => import("./containers/Home"));
const PeopleSearch = React.lazy(() => import("./containers/PeopleSearch"));
const EventSearch = React.lazy(() => import("./containers/EventSearch"));
const AttendeePage = React.lazy(() => import("./containers/AttendeePage"));
const AttendeePageSub = React.lazy(() => import("./containers/AttendeePage"));
const EventPage = React.lazy(() => import("./containers/EventPage"));

const CpeMod = () => {
    useEffect(() => {
        // Notify Login
        const db = ApiPath.db;
        const endpoint =
            "https://wcf" +
            db +
            "svcadmin.xyvid.com/api/UserActivity/PostUserActivity?UserActivityTypeId=71&SessionID=&EventId=0&ContentId=0&ContentType=&ActivityNotes=";
        fetch(endpoint, { method: "POST" });
    }, []);

    return (
        // Manages Routing With History And Routes
        <Router history={history}>
            <Suspense fallback={<Loading />}>
                <Switch>
                    <Route path="/login" exact component={Login} />
                    <ProtectedRoute path="/" exact component={Home} />
                    <ProtectedRoute
                        exact
                        path="/peopleSearch"
                        component={PeopleSearch}
                    />
                    <ProtectedRoute
                        exact
                        path="/eventSearch"
                        component={EventSearch}
                    />
                    <ProtectedRoute
                        path="/peopleSearch/:attNum/:eventId"
                        exact
                        component={AttendeePage}
                    />
                    <ProtectedRoute
                        path="/peopleSearch/sub/:attNum/:eventId"
                        exact
                        component={AttendeePageSub}
                    />
                    <ProtectedRoute
                        path="/eventSearch/:eventId"
                        exact
                        component={EventPage}
                    />
                </Switch>
            </Suspense>
        </Router>
    );
};

export default CpeMod;
